import DOMPurify, { Config } from 'dompurify';
import React from 'react';

const defaultOptions = {
  ALLOWED_ATTR: ['href', 'style', 'src', 'class', 'content', 'border', 'height', 'id', 'alt'],
  ALLOWED_TAGS: [
    'a',
    'b',
    'blockquote',
    'body',
    'br',
    'div',
    'em',
    'font',
    'head',
    'html',
    'i',
    'img',
    'li',
    'meta',
    'ol',
    'p',
    'pre',
    'span',
    'strong',
    'ul',
    'table',
    'tr',
    'td',
    'th',
    's',
  ],
};

export const sanitizeHtml = (dirty: string, options?: Config) => ({
  __html: DOMPurify.sanitize(dirty, { ...defaultOptions, ...options }),
});

type Props = {
  html: string;
  options?: Config;
};

export const SanitizeHTML: React.FC<Props> = ({ html, options }) => {
  const sanitized = sanitizeHtml(replaceEmailAngleBrackets(html), options);

  // eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml
  return <div className="sanitizedContent" dangerouslySetInnerHTML={sanitized} />;
};

const replaceEmailAngleBrackets = (html: string): string => {
  return html.replaceAll(/<([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})>/g, '&lt;$1&gt;');
};
